<template>
  <div class="app-container">
    <div class="page-title">
      <h2>{{ $t('disease.diseases') }}</h2>
    </div>
    <el-card v-if="checkRole(['Admin'])" class="box-card filter-card just-for-admin">
      <div slot="header" class="clearfix">
        <span>{{ $t('general.filter') }}</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="initSearch">{{ $t('general.init') }}</el-button>
      </div>
      <div class="filter-container">
        <el-radio v-model="activeList" label="actives" border @change="getSubDiseasesList('indexactive')">{{ $t('general.F_actives') }}</el-radio>
        <el-radio v-model="activeList" label="desactives" border @change="getSubDiseasesList('indexdesactive')">{{ $t('general.F_desactives') }}</el-radio>
        <el-radio v-model="activeList" label="disponibles" border @change="handleFilterDiseases">{{ $t('general.disponibles') }}</el-radio>
        <el-radio v-model="activeList" label="corbeille" class="danger-radio" border @change="getSubDiseasesList('indexinvisible')">{{ $t('general.corbeille') }}</el-radio>
      </div>
    </el-card>

    <el-card class="box-card">
      <div class="filter-container">
        <el-input v-model="query.keyword" clearable :placeholder="$t('general.keyword')" class="wd-200 mr-15 filter-item" @keyup.enter.native="handleFilterDiseases" />
        <el-button v-waves class="mr-15 filter-item" type="primary" icon="el-icon-search" @click="handleFilterDiseases">
          {{ $t('general.search') }}
        </el-button>
        <el-button v-waves :loading="downloading" class="filter-item" type="primary" icon="el-icon-download" @click="handleDownload">
          {{ $t('general.export') }}
        </el-button>
        <el-button v-if="checkPermission(['create disease'])" class="mr-15 filter-item" type="primary" icon="el-icon-plus" @click="handleCreateDisease">
          {{ $t('general.add') }}
        </el-button>
      </div>
      <el-table v-loading="loading" :data="list" border fit highlight-current-row style="width: 100%">

        <el-table-column align="center" :label="$t('disease.name')">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('disease.body')">
          <template slot-scope="scope">
            <span>{{ scope.row.description }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="activeList!='corbeille' && checkPermission(['activate disease'])" align="center" :label="$t('general.status')" width="150">
          <template slot-scope="scope">
            <el-switch
              style="display: block"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
              :value="scope.row.is_active"
              :disabled="!scope.row.is_visible"
              @change="setDiseaseStatus(scope.row.id,'active')"
            />
          </template>
        </el-table-column>

        <el-table-column v-if="checkRole(['Admin']) && (activeList=='corbeille' || query.keyword)" align="center" :label="$t('general.restaurer')" width="100">
          <template slot-scope="scope">
            <el-switch
              v-if="!scope.row.is_visible"
              style="display: block"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
              :value="scope.row.is_visible"
              @change="setDiseaseStatus(scope.row.id,'visible')"
            />
          </template>
        </el-table-column>
        <el-table-column v-if="checkPermission(['edit disease','hide disease','delete disease'])" align="center" :label="1==1 ? $t('general.actions') : $t('general.suppressionDefinitive')" width="150">
          <template slot-scope="scope">
            <el-button v-if="scope.row.is_visible && checkPermission(['edit disease'])" type="primary" size="small" icon="el-icon-view" style="margin-right:10px;" @click="handleEditDisease(scope.row.id);" />
            <el-button v-if="checkPermission(['hide disease','delete disease'])" slot="reference" type="danger" size="small" icon="el-icon-delete" style="margin-right:10px;" @click="handleDeleteDisease(scope.row.id, scope.row.is_visible, scope.row.name);" />
          </template>
        </el-table-column>
      </el-table>

      <pagination v-if="total > 0" :total="total" :page.sync="query.page" :limit.sync="query.limit" @pagination="getDiseasesList" />

      <!-- ======= Disease FORM ======= -->
      <el-dialog
        :title="editing ? $t('disease.edit') + ' ' + currentDisease.name : $t('disease.AddDisease')"
        :visible.sync="dialogCreateDisease"
        :before-close="handleCloseDiseaseCreateDraw"
        :loading="diseaseCreating"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="50%"
      >
        <div class="content-inputs">
          <el-form ref="diseaseForm" :rules="rules" :model="currentDisease" label-position="left" @keyup.enter.prevent="editing ? updateDisease() : createDisease()">
            <el-form-item :label="$t('disease.name')" prop="name">
              <el-input v-model="currentDisease.name" />
            </el-form-item>
            <el-form-item :label="$t('disease.body')" prop="description">
              <el-input v-model="currentDisease.description" type="textarea" />
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <div style="text-align:right;">
            <el-button plain type="danger" @click="dialogCreateDisease=false">
              {{ $t('permission.cancel') }}
            </el-button>
            <el-button type="primary" :loading="diseaseCreating" @click="editing ? updateDisease() : createDisease()">
              {{ diseaseCreating ? $t('general.saving') : $t('general.save') }}
            </el-button>
          </div>
        </span>
      </el-dialog>

      <!-- <el-drawer
        :title="$t('alert.alert')"
        :visible.sync="dialogCreateAlert"
        :before-close="handleCloseAlertCreateDraw"
        :loading="alertCreating"
        size="30%"
      >
        <div class="content-inputs" style="padding:30px">
          <div class="full-width">
            <div class="half-photo">
              <div class="demo-basic--circle">
                <div>
                  <el-avatar shape="square" :size="50" :src="currentAlert.author.avatar" />
                </div>
              </div>
            </div>
            <div class="half-right">
              <div class="in-td">
                <h4>{{ currentAlert.author.name }}</h4>
                <small>{{ currentAlert.author.email }}</small>
              </div>
            </div>
          </div>
          <el-divider />
          <div class="alert-subject margin-top">
            <h3>{{ $t('alert.subject') }}</h3>
            <p>
              {{ currentAlert.subject }}
            </p>
          </div>
          <div class="alert-body margin-top">
            <h3>{{ $t('alert.body') }}</h3>
            <p class="body-text">
              {{ currentAlert.body }}
            </p>
          </div>
          <el-divider />
          <el-card class="box-card">
            <el-form ref="alertForm" :rules="rules" :model="currentAlert" label-position="left">
              <el-form-item :label="$t('general.processing')" prop="processing">
                <el-radio-group v-model="currentAlert.processing">
                  <el-radio
                    v-for="(processing, idex) in processings"
                    :key="idex"
                    :label="processing"
                    :class="'radio-'+getprocessingColor(processing)"
                  > {{ processing | uppercaseFirst }} </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
            <span>
              <div style="text-align:right;">
                <el-button plain type="danger" @click="dialogCreateAlert=false">
                  {{ $t('general.close') }}
                </el-button>
                <el-button type="primary" :loading="alertCreating" @click="editing ? updateAlert() : createAlert()">
                  {{ alertCreating ? $t('general.saving') : $t('general.save') }}
                </el-button>
              </div>
            </span>
          </el-card>
        </div>
      </el-drawer> -->

      <!-- ======= END Disease FORM ======= -->

    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'; // Pagination
import Resource from '@/api/resource';
import waves from '@/directive/waves'; // Directives
import permission from '@/directive/permission'; //  directive Permission
import role from '@/directive/role'; // Directives Role
import checkPermission from '@/utils/permission'; // Vérification Permission
import checkRole from '@/utils/role'; // Vérification Roles
import moment from 'moment';
const diseaseResource = new Resource('diseases');
export default {
  name: 'DiseasesList',
  components: { Pagination },
  directives: { waves, permission, role },
  data() {
    return {
      list: null,
      total: 0,
      loading: false,
      downloading: false,
      diseaseCreating: false,
      editing: false,
      activeList: 'disponibles',
      query: {
        page: 1,
        limit: this.$limit,
        keyword: '',
      },
      currentDisease: {},
      dialogCreateDisease: false,
      currentDiseaseId: 0,
      rules: {
        name: [{ required: true, message: this.$t('disease.NameRequired'), trigger: 'blur' }],
      },
    };
  },
  computed: {
  },
  created() {
    this.resetNewDisease();
    this.getDiseasesList();
  },
  methods: {
    checkPermission,
    checkRole,
    isEmptyArray(array){
      if (typeof array !== 'undefined' && array.length === 0) {
        return true;
      }
    },
    handleCloseDiseaseCreateDraw(done) {
      this.$confirm(this.$t('general.closingWarningText'))
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    cancelDiseaseForm() {
      this.$refs.DiseaseCreationDrawer.closeDrawer();
    },
    initSearch(){
      this.query = {
        page: 1,
        limit: this.$limit,
        keyword: '',
      };
      this.activeList = 'disponibles';
      this.handleFilterDiseases();
    },
    async getDiseasesList() {
      this.loading = true;
      const { limit, page } = this.query;
      const { data, meta } = await diseaseResource.list(this.query);
      this.list = data;
      this.list.forEach((element, index) => {
        element['index'] = (page - 1) * limit + index + 1;
      });
      this.total = meta.total;
      this.loading = false;
    },
    async getSubDiseasesList(subUrl) {
      this.loading = true;
      const { data } = await diseaseResource.sublist('/' + subUrl, this.query);
      this.list = data;
      this.loading = false;
    },
    handleFilterDiseases() {
      this.query.page = 1;
      this.getDiseasesList();
    },
    handleCreateDisease() {
      this.editing = false;
      this.resetNewDisease();
      this.dialogCreateDisease = true;
      this.$nextTick(() => {
        this.$refs['diseaseForm'].clearValidate();
      });
    },
    handleEditDisease(id){
      this.editing = true;
      this.resetNewDisease();
      this.currentDisease = this.list.find(abonne => abonne.id === id);
      this.dialogCreateDisease = true;
      this.$nextTick(() => {
        this.$refs['diseaseForm'].clearValidate();
      });
    },
    async setDiseaseStatus(id, type){
      const data = await diseaseResource.get('toogle_' + type + '/' + id);
      if (data.success){
        this.$message({
          type: 'success',
          message: this.$t('general.statusUpdated'),
        });
        this.initSearch();
      } else {
        this.$message({
          type: 'danger',
          message: this.$t('general.statusUpdateError'),
        });
      }
    },
    handleDeleteDisease(id, visible, name) {
      this.$confirm(this.$t('disease.deleteWarn') + ' ' + name + '. ' + this.$t('general.deleteContinue'), 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: this.$t('general.cancel'),
        type: 'warning',
      }).then(() => {
        if (!visible && (checkRole(['Admin']) || checkPermission(['delete disease']))) {
          this.$swal({
            title: this.$t('general.SureQuestion'),
            text: this.$t('general.irrversibleMessage'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('general.ouiSupprimer'),
          }).then((result) => {
            if (result.isConfirmed) {
              diseaseResource.destroy(id).then(response => {
                this.$message({
                  type: 'success',
                  message: this.$t('disease.suppressionEffectue'),
                });
                this.initSearch();
              }).catch(error => {
                console.log(error);
              });
            }
          });
        } else {
          this.setDiseaseStatus(id, 'visible');
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('general.suppressionAnnule'),
        });
      });
    },
    createDisease() {
      this.$refs['diseaseForm'].validate((valid) => {
        if (valid) {
          this.diseaseCreating = true;
          diseaseResource
            .store(this.currentDisease)
            .then(async(response) => {
              this.$message({
                message: this.$t('disease.NewDisease') + ' ' + this.currentDisease.name + ' ' + this.$t('disease.iscreatedSuccessfully'),
                type: 'success',
                duration: 5 * 1000,
              });
              this.currentDiseaseId = response.data.id;
              this.resetNewDisease();
              this.dialogCreateDisease = false;
              this.handleFilterDiseases();
            })
            .catch(error => {
              console.log(error);
            })
            .finally(() => {
              this.diseaseCreating = false;
            });
        } else {
          this.$message({
            type: 'danger',
            message: this.$t('general.invalidForm'),
          });
          return false;
        }
      });
    },
    updateDisease() {
      this.$refs['diseaseForm'].validate((valid) => {
        if (valid) {
          this.diseaseCreating = true;
          diseaseResource.update(this.currentDisease.id, this.currentDisease).then(response => {
            this.resetNewDisease();
            this.handleFilterDiseases();
            this.$message({
              message: this.$t('disease.isupdatedSuccessfully'),
              type: 'success',
              duration: 5 * 1000,
            });
            this.dialogCreateDisease = false;
            this.editing = false;
          })
            .catch(error => {
              console.log(error);
            })
            .finally(() => {
              this.diseaseCreating = false;
            });
        } else {
          this.$message({
            type: 'danger',
            message: this.$t('general.invalidForm'),
          });
          return false;
        }
      });
    },
    resetNewDisease() {
      this.currentDisease = {
        name: '',
        description: '',
      };
    },
    handleDownload() {
      this.downloading = true;
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = ['ID', this.$t('disease.name'), this.$t('disease.body')];
        const filterVal = ['id', 'name', 'description'];
        const data = this.formatJson(filterVal, this.list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'Diseases list GEOSANTE_' + moment().format('DD-MM-YYYY_hh-mm'),
        });
        this.downloading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
  },
};
</script>

<style lang="scss" scoped>
.half-right {
    width: 70% !important;
    float: none !important;
    text-align: left !important;
    padding: 10px;
}
.edit-input {
  padding-right: 100px;
}
.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
.dialog-footer {
  text-align: left;
  padding-top: 0;
  margin-left: 150px;
}
.app-container {
  flex: 1;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  .block {
    float: left;
    min-width: 250px;
  }
  .clear-left {
    clear: left;
  }
}
</style>
